import React from 'react';
import css from './TopServiceWrapper.module.css';
import { Link } from 'react-router-dom';
import TopServiceCard from '../../elements/top-service-card/TopServiceCard';

const GRADIENTS = [
  'linear-gradient(135deg, #1a4731 0%, #0d2818 100%)',
  'linear-gradient(135deg, #4c1d95 0%, #2d1060 100%)',
  'linear-gradient(135deg, #0e4f4f 0%, #082f2f 100%)',
  'linear-gradient(135deg, #7c3d1a 0%, #4a2210 100%)',
  'linear-gradient(135deg, #0d4f2f 0%, #062e1a 100%)',
  'linear-gradient(135deg, #7c1a1a 0%, #4a0f0f 100%)',
  'linear-gradient(135deg, #0e6b5a 0%, #064035 100%)',
  'linear-gradient(135deg, #3b1680 0%, #1f0c44 100%)',
  'linear-gradient(135deg, #0e1f4f 0%, #060c2e 100%)',
];

export default function TopServiceWrapper(props) {
  let { heading, subtitle, service_list } = props;
  service_list = service_list || [];

  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <div className={css.headerText}>
          <h2 className={css.heading}>{heading}</h2>
          {subtitle && <p className={css.subtitle}>{subtitle}</p>}
        </div>
        <Link className={css.allCats} to="/s">
          All categories &rsaquo;
        </Link>
      </div>

      <div className={css.grid}>
        {service_list.map((service, index) => (
          <div
            key={service.key + '_' + index}
            className={index === 0 ? css.heroItem : css.gridItem}
          >
            <TopServiceCard
              img={service.image}
              title={service.label}
              filter={service.key}
              gradient={service.gradient || GRADIENTS[index % GRADIENTS.length]}
              count={service.count}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
